import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setCredentials } from './authSlice'
import { useLoginMutation } from './authApiSlice'
import usePersist from '../../hooks/usePersist'
import useTitle from '../../hooks/useTitle'
import PulseLoader from 'react-spinners/PulseLoader'
import { toast } from 'react-toastify'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUser } from "@fortawesome/free-solid-svg-icons"

const Login = () => {
    useTitle('DPE Login')

    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [persist, setPersist] = usePersist()

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [login, { isLoading }] = useLoginMutation()

    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            const { accessToken } = await login({ username, password }).unwrap()
            dispatch(setCredentials({ accessToken }))
            toast.success('Login Succesful. WELCOME!')
            setUsername('')
            setPassword('')
            navigate('/dash')
        } catch (err) {
            if (!err.status) {
                toast.error('No Server Response')
            } else if (err.status === 400) {
                toast.error('Missing Username or Password');
            } else if (err.status === 401) {
                toast.error('Unauthorized');
            } else {
                toast.error(err.data?.message);
            }
        }
    }

    const handleUserInput = (e) => setUsername(e.target.value)
    const handlePwdInput = (e) => setPassword(e.target.value)
    const handleToggle = () => setPersist(prev => !prev)

    if (isLoading) return (
        <>
        <div>Login can take up to 1 minute<br/></div>
        <PulseLoader color={"#5f788a"} />
        </>
    )

    const content = (
        <section id="main_content">
            <header>
                <h1 className="text-steel mt-5"><FontAwesomeIcon icon={faUser} style={{fontSize:"30px", marginRight:"5px"}} />Login</h1>
            </header>
            <main className="mt-5">
                <div className="row">
                    <div className="col-md-4 rounded p-3 bg-secondary bg-opacity-25">
                        <form onSubmit={handleSubmit}>
                            <label htmlFor="username" className="form-label">Username:</label>
                            <input
                                className="form-control"
                                type="text"
                                id="username"
                                value={username}
                                onChange={handleUserInput}
                                autoComplete="off"
                                required
                            />

                            <label htmlFor="password" className="form-label">Password:</label>
                            <input
                                className="form-control"
                                type="password"
                                id="password"
                                onChange={handlePwdInput}
                                value={password}
                                required
                            />
                            <div className="d-grid gap-2">
                                <button className="btn btn-steel mt-3">Sign In</button>
                                <label htmlFor="persist" className="form-label">
                                    <input
                                        type="checkbox"
                                        className="form__checkbox"
                                        id="persist"
                                        onChange={handleToggle}
                                        checked={persist}
                                    />
                                    Trust This Device
                                </label>                                
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        </section>
    )

    return content
}
export default Login